import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'

type CancelRequestDocumentPayload = {
  claimFormId: string
  requestDocumentHistoryId: string
}

const postCancelRequestDocument = async (claimFormId: string, requestDocumentHistoryId: string) => {
  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/${claimFormId}/cancel-request-document`,
    {
      requestDocumentHistoryId,
    },
  )

  return response.data
}

const useCancelRequestDocument = () => {
  return useMutation({
    mutationKey: ['useCancelRequestDocument'],
    mutationFn: async (variables: CancelRequestDocumentPayload) => {
      const { claimFormId, requestDocumentHistoryId } = variables
      return postCancelRequestDocument(claimFormId, requestDocumentHistoryId)
    },
  })
}

export default useCancelRequestDocument
